import { render, staticRenderFns } from "./UserSignupLinkCreateDrawer.vue?vue&type=template&id=4ff5a10e&scoped=true"
import script from "./UserSignupLinkCreateDrawer.vue?vue&type=script&lang=js"
export * from "./UserSignupLinkCreateDrawer.vue?vue&type=script&lang=js"
import style0 from "./UserSignupLinkCreateDrawer.vue?vue&type=style&index=0&id=4ff5a10e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff5a10e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff5a10e')) {
      api.createRecord('4ff5a10e', component.options)
    } else {
      api.reload('4ff5a10e', component.options)
    }
    module.hot.accept("./UserSignupLinkCreateDrawer.vue?vue&type=template&id=4ff5a10e&scoped=true", function () {
      api.rerender('4ff5a10e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/UserSignupLinkCreateDrawer.vue"
export default component.exports